<template>
  <v-container class="app-container--width-max">
    <h1>Application complete: {{ this.getApplicationReference }}</h1>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { APPLICATION_MODULE } from "@/store/types/module-types";

export default {
  name: "ApplicationComplete",
  computed: {
    ...mapGetters(APPLICATION_MODULE, ["getApplicationReference"]),
  },
};
</script>

<style lang="scss" scoped></style>
